import { PrimaryControlsStripBack } from "@-/dev.improve.haniverse.routes.nav._components.primary-controls-strip.back";
import type { ReactNode } from "react";

/** Keeps character panels opened from a collection inside the Collections tab's own stack. */
export function CollectionsMorphemeLayout({ children }: { children: ReactNode }) {
  return (
    <>
      <PrimaryControlsStripBack appShellPlacement="toolbar" fallbackHref="/(nav)/(app)/collections">
        Collections
      </PrimaryControlsStripBack>
      {children}
    </>
  );
}
